import Context from "shared/util/Context";
import Payment from "./containers/Payment";
import AndroidPayment from "./containers/AndroidPayment";

const Component = Context.has("ANDROID_PAYMENT_FUNNEL")
	? AndroidPayment
	: Payment;

if (process.env.PLATFORM === "mobile") {
	require("./App.mobile.scss");
} else {
	require("./App.desktop.scss");
}

export default Component;



// WEBPACK FOOTER //
// ./src/apps/payment/index.js